import { createContext, useContext } from "react";

export type DrawerContextValue = {
  isSwipeable: boolean;
  isScrolled: boolean;
  backgroundColor: "white" | "background";
  onTopBarMount?: () => void;
  onTopBarUnmount?: () => void;
};

export const DrawerContext = createContext<DrawerContextValue>({
  backgroundColor: "white",
  isScrolled: false,
  isSwipeable: false,
});

export const useDrawerContext = () => {
  const context = useContext(DrawerContext);

  return context;
};
